import { useEffect } from 'react';

import { mainActions } from '../../../store/index.js';
import { useDispatcher } from '../../hooks/index.js';

export const OfflineMonitor: FC = () => {
    const setOffline = useDispatcher(mainActions.SetOffline);
    const setFocused = useDispatcher(mainActions.SetFocused);

    useEffect(() => {
        window.addEventListener('offline', (e) => {
            setOffline(true);
        });

        window.addEventListener('online', (e) => {
            setOffline(false);
        });
    }, []);

    useEffect(() => {
        window.addEventListener('focus', (e) => {
            setFocused(true);
        });

        window.addEventListener('blur', (e) => {
            setFocused(false);
        });
    }, []);

    return null;
};

export default OfflineMonitor;
